import Model from './Model';

class AutoAllocation extends Model {
  autoallocation = '';

  static fromJSON(json) {
    if (Array.isArray(json)) {
      return json.map(AutoAllocation.fromJSON);
    }

    const autoallocation = new AutoAllocation();

    return autoallocation.mapValues(autoallocation, json);
  }
}

export default AutoAllocation;
